<template>
  <AeModal 
    :model-value="modelValue" 
    :title="title || t('operationObservationModal.defaultTitle')"
    size="large" 
    flex-body 
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <OperationObservationForm
      ref="formRef"
      v-if="modelValue && idFarmCenter && idSeason"
      :type="type"
      :id-farm-center="idFarmCenter"
      :id-season="idSeason"
      :edit-object="editObject"
      :pre-selected-type="preSelectedType"
      :pre-selected-date="preSelectedDate"
      :pre-selected-fields="preSelectedFields"
      :pre-selected-product-id="preSelectedProductId"
      :pre-selected-trap-id="preSelectedTrapId"
      @saved="$emit('saved', $event)"
      @cancel="$emit('cancel')"
    />
    <template #footer>
      <!-- Step: dateField - Navigazione campo -->
      <template v-if="formRef?.currentStep === 'dateField'">
        <AeButton variant="secondary" @click="formRef.currentStep = 'type'">{{ t('operationObservationModal.back') }}</AeButton>
        <AeButton
          variant="primary"
          @click="formRef?.goToForm()"
          :disabled="!formRef?.formData?.id_fields || formRef?.formData?.id_fields?.length === 0"
        >
          {{ t('operationObservationModal.next') }}
        </AeButton>
      </template>

      <!-- Step: form - Pulsanti salva -->
      <template v-else-if="formRef?.currentStep === 'form'">
        <AeButton variant="secondary" @click="formRef?.handleCancel()">{{ t('operationObservationModal.cancel') }}</AeButton>
        <AeButton variant="success" @click="formRef?.handleSubmit()">
          {{ editObject ? t('operationObservationModal.update') : t('operationObservationModal.save') }}
        </AeButton>
      </template>
    </template>
  </AeModal>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { AeModal, AeButton } from '@aevue/components'
import OperationObservationForm from './OperationObservationForm.vue'

const { t } = useI18n()

defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    required: true,
    validator: (value) => ['crop_operation', 'observation'].includes(value)
  },
  idFarmCenter: {
    type: String,
    required: true
  },
  idSeason: {
    type: String,
    default: null
  },
  editObject: {
    type: Object,
    default: null
  },
  preSelectedType: {
    type: [String, Number],
    default: null
  },
  preSelectedDate: {
    type: String,
    default: null
  },
  preSelectedFields: {
    type: Array,
    default: () => []
  },
  preSelectedProductId: {
    type: String,
    default: null
  },
  preSelectedTrapId: {
    type: String,
    default: null
  }
})

defineEmits(['update:modelValue', 'saved', 'cancel'])

const formRef = ref(null)
</script>
